"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventBus = void 0;
var event_bus_1 = require("@idp/event-bus");
var observerID = '1';
var observerConfig = {
    // tslint:disable-next-line:no-any
    eventHandler: function (eventData) { console.log('from observable'); },
    observerId: observerID,
    serviceName: 'data_handshake',
};
/**
 * Syntax compatible with nodejs native EventEmitter
 * @property emit(eventName, payload Object) - Trigger/fire events with eventName and payload
 * @property on(eventName, callback(payload)) - add listeners to event
 * @author Samarjit Samanta
 */
exports.EventBus = {
    /**
     * Trigger events with eventName and payload
     */
    emit: function (eventName, payload) {
        if (exports.EventBus.listObservers[eventName]) { // .forEach((cb) => cb(payload));
            event_bus_1.ICCEventBusManager.getInstance().notifyObservers('1', eventName, payload);
        }
    },
    listObservers: {},
    /**
     * To remove event listeners
     * @FIXME ICCEventBusManager does not remove by object identity
     */
    // tslint:disable-next-line:no-any
    off: function (eventName, callback, observerId) {
        if (exports.EventBus.listObservers[eventName].indexOf(callback) === -1) {
            var idx = exports.EventBus.listObservers[eventName].indexOf(callback);
            exports.EventBus.listObservers[eventName].splice(idx, 1);
        }
        event_bus_1.ICCEventBusManager.getInstance().deregisterObserver(observerId);
    },
    /**
     * Listens to events and calls the callback when event occurs
     */
    // tslint:disable-next-line:no-any
    on: function (eventName, callback) {
        var observeeID = observerConfig.observerId; // ICCEventBusManager.getUUID();
        observeeID = (parseInt(observeeID, 10) + 1) + '';
        observerConfig.eventHandler = callback;
        observerConfig.serviceName = eventName;
        observerConfig.observerId = observeeID;
        if (exports.EventBus.listObservers[eventName] === undefined) {
            // New event
            if (!exports.EventBus.listObservers[eventName]) {
                exports.EventBus.listObservers[eventName] = [];
            }
            event_bus_1.ICCEventBusManager.getInstance().configObserverable({ observerableId: '1', serviceNames: [eventName] });
            event_bus_1.ICCEventBusManager.getInstance().registerObserver(__assign({}, observerConfig));
            exports.EventBus.listObservers[eventName].push(callback);
        }
        else if (exports.EventBus.listObservers[eventName].indexOf(callback) === -1) {
            // Old even but new listener
            observerConfig.observerId = observeeID;
            exports.EventBus.listObservers[eventName].push(callback);
            event_bus_1.ICCEventBusManager.getInstance().registerObserver(__assign({}, observerConfig));
        }
        return observeeID;
    },
};
//# sourceMappingURL=EventBus.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/api/EventBus.js
// module id = 2215
// module chunks = 8